<div class="max-reward-container" [class.acca-boost-max-reward-enhanced]="isEnhancedLayoutEnabled">
    @if (isEnhancedLayoutEnabled) {
        <vn-icon name="theme-acca-boost" size="12" />
    } @else {
        <vn-icon name="theme-check" size="16" class="acca-boost-theme-check" />
    }
    <div>{{ sitecore.accaBoost.MaxRewardAchieved }}</div>
</div>
<div class="max-reward-limit">{{ sitecore.accaBoost.MaxRewardReturns | msInterpolate: { maxReturns: maxReturns | bsCurrency: true } }}</div>
